import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  SignInPageBlueprint,
  type SignInPageProps,
} from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { oidcAuthApiRef } from '../oidcAuthApi';

// Backstage's New Backend System rejects unauthenticated requests by default
// (the auth policy 401s anything without a Backstage-issued session token).
// Sign-in uses the OIDC provider (Microsoft Entra ID in rpt-labs).

const oidcSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: SignInPageProps) => (
      <SignInPage
        {...props}
        providers={[
          {
            id: 'oidc',
            title: 'Sign in with Microsoft Entra ID',
            message: 'Use your River Point Technology account',
            apiRef: oidcAuthApiRef,
          },
        ]}
      />
    ),
  },
});

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [oidcSignInPage],
});
